<script setup lang="ts">
import { computed } from 'vue'
import { useField } from 'vee-validate'
import Calendar from 'primevue/calendar'
import { formatedDate } from '@/constants'
import InputText from 'primevue/inputtext'

const props = defineProps<{
  modelValue?: any
  inputName: string
  disabled?: boolean
  label: string
}>()

const emit = defineEmits(['update:modelValue'])

const { value, errorMessage } = useField<any>(props.inputName)

const computedValue = computed({
  get: () => {
    if (!props.modelValue) return null

    const date = new Date(props.modelValue)
    return isNaN(date.getTime()) ? null : date
  },
  set: (newVal: any) => {
    value.value = newVal ? new Date(newVal).toISOString() : null
    emit('update:modelValue', value.value)
  }
})

// This computed is for formatting the date when 'disabled' is true
const formatedKnittedDate = computed(() => {
  // Format the date only if it's present and valid, else return an empty string
  return computedValue.value ? formatedDate(computedValue.value) : ''
})
</script>

<template>
  <div class="flex flex-col gap-2">
    <label for="dateCarriedOut">{{ label }}</label>
    <InputText v-if="disabled" v-model="formatedKnittedDate" :disabled="disabled" />
    <Calendar
      v-else
      id="dateCarriedOut"
      placeholder=""
      :invalid="!!errorMessage"
      v-model="computedValue"
      showIcon
      iconDisplay="input"
      :disabled="disabled"
      class="w-full"
      dateFormat="dd/mm/yy"
    />
  </div>
</template>

<style scoped></style>
